import Router from './Router/Router'
import './App.css';

export default function App() {
  return (    
    <Router />
  );
}